import React, { createContext } from 'react'
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router} from 'react-router';

import ApplicationContextProvider from './app-ctx';
import IndexRouter from './index-router';
import IndexPage from './index-page';
import ResortsPage from './resorts-page';
import ResortPage from './resort-page';
import SideFilters from './side-filters';
import BookPage from './book-page';
import ProfilePage from './profile-page';
import './app.css';
import './app.additinal.css'

const searchFormNode = document.getElementById('app_search_form');
if (searchFormNode !== null) {
  const searchForm = createRoot(searchFormNode);
  
    //<IndexPage>
    //  <Tabbed>
    //    <SearchForm>

  searchForm.render(
    <ApplicationContextProvider>
      <IndexPage  />
    </ApplicationContextProvider>
  );
}

const resortListNode = document.getElementById('resort_list');
if (resortListNode !== null) {
  const resortList = createRoot(resortListNode);
  resortList.render(
    <ApplicationContextProvider>
      <ResortsPage />
    </ApplicationContextProvider>
  );
} 

const resortNode = document.getElementById('resort_page');
if (resortNode !== null) {
  const resortId = resortNode.dataset.resortId
  const resort = createRoot(resortNode);
  resort.render(
    <ApplicationContextProvider>
      <ResortPage resortId={resortId} />
    </ApplicationContextProvider>
  );
} 

const toBookNode = document.getElementById('resort_booking');
if (toBookNode !== null) {
  const resortId = toBookNode.dataset.resortId
  const book = createRoot(toBookNode);
  book.render(
    <ApplicationContextProvider>
      <BookPage resortId={resortId} />
    </ApplicationContextProvider>
  );
} 


const sideFiltersNode = document.getElementById('kurort_life_filters');
if (sideFiltersNode !== null) {
  const sideFiltersRoot = createRoot(sideFiltersNode);
  sideFiltersRoot.render(
    <ApplicationContextProvider>
      <SideFilters />
    </ApplicationContextProvider>
  );
}

const profileNode = document.getElementById('kurortlife_profile');
if (profileNode !== null) {
  const profileRoot = createRoot(profileNode);
  profileRoot.render(
    <ApplicationContextProvider>
      <ProfilePage />
    </ApplicationContextProvider>
  );
}

